import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phonenumbersplit',
  standalone: true
})
export class PhonenumbersplitPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (value) {
      const phonenumbersplitted = value.split(' ');
      return phonenumbersplitted[1];
    }
  }

}
